/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'error': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M23.201 29.496a.394.394 0 0 0-.402-.49h-1.476c-.275 0-.438-.216-.359-.479l1.295-5.047c.074-.264-.086-.48-.361-.48h-2.529c-.275 0-.43-.214-.346-.476l3.348-10.049a.736.736 0 0 1 .654-.475h6.607c.275 0 .402.203.283.45l-4.08 7.131c-.119.248.008.448.283.445l2.53-.026c.275-.004.399.195.275.441l-2.426 6.143c-.123.246.002.447.277.447h1.498c.274 0 .361.178.191.395l-6.379 8.436c-.168.217-.264.174-.209-.096l1.326-6.27z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/error.js